import { review } from '../data/review.mjs';

export const siteOrigin = 'https://modeck.io';
export const pages = [
  {
    path: '/', name: 'Home', sitemap: true,
    title: 'After Effects Template Automation for Teams | MoDeck',
    heading: 'Let your team edit After Effects templates in a browser.',
    description: 'Turn After Effects MOGRTs into browser-editable templates. Let your team create video versions and automate rendering on your own connected machine.',
    image: '/assets/social/home.png', imageAlt: 'MoDeck: After Effects design, browser editing, and rendering on your machine.',
  },
  {
    path: '/docs', name: 'Docs', sitemap: true,
    title: 'MoDeck Docs: MOGRT Setup, Editing & Rendering',
    heading: 'MoDeck documentation: from MOGRT to finished video',
    description: 'Learn to publish MOGRT templates, configure browser editing, connect CSV, Google Sheets or JSON, and render finished versions with MoDeck.',
    image: '/assets/social/docs.png', imageAlt: 'MoDeck documentation: MOGRT setup, browser editing, and rendering.',
  },
  {
    path: '/downloads', name: 'Downloads', sitemap: true,
    title: 'Download the MoDeck Desktop App for Windows & macOS',
    heading: 'Download MoDeck for Windows and macOS',
    description: 'Install MoDeck on your Windows or Mac render machine to sync After Effects templates, generate previews, and render edits created in the browser.',
    image: '/assets/social/downloads.png', imageAlt: 'Download the MoDeck desktop app for Windows and macOS.',
  },
  {
    path: '/modeck-review', name: 'Review', sitemap: true,
    title: 'MoDeck Review: Features, Pricing & Limitations - Official Guide',
    heading: 'MoDeck Review 2026: what it does, what it needs, and who it fits',
    description: 'Explore MoDeck’s browser editing, After Effects automation, and unlimited local rendering on Enterprise. An official guide to pricing, benefits, and limitations.',
    image: '/assets/social/review.png', imageAlt: 'The official MoDeck guide to features, requirements, and fit.',
  },
  {
    path: '/privacy-policy', name: 'Privacy Policy', sitemap: false,
    title: 'Privacy Policy | MoDeck', heading: 'Privacy Policy',
    description: 'Read how MoDeck handles account information, service data, analytics choices, and your privacy rights.',
  },
  {
    path: '/terms-and-conditions', name: 'Terms And Conditions', sitemap: false,
    title: 'Terms and Conditions | MoDeck', heading: 'Terms and Conditions',
    description: 'Read the terms for using MoDeck, including accounts, subscriptions, licensing, and responsibilities when using the service.',
  },
];

export const notFoundPage = {
  name: 'NotFound', title: 'Page not found | MoDeck', heading: 'Page not found',
  description: 'This page could not be found. Visit MoDeck’s homepage, documentation, or downloads to continue.',
  index: false, sitemap: false,
};

export function pageForPath(pathname) {
  return pages.find(page => page.path === pathname) || notFoundPage;
}

export function markdownPath(page) {
  return page.path === '/' ? '/index.md' : `${page.path}.md`;
}

export function canonicalPath(pathname) {
  if (pathname === '/index.html') return '/';
  const path = pathname.replace(/\/+$/, '') || '/';
  return pages.some(page => page.path === path) ? path : null;
}

export function structuredData(page) {
  if (page.path === '/') return {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'Organization', '@id': `${siteOrigin}/#organization`, name: 'MoDeck', url: `${siteOrigin}/` },
      { '@type': 'WebSite', '@id': `${siteOrigin}/#website`, name: 'MoDeck', url: `${siteOrigin}/`, publisher: { '@id': `${siteOrigin}/#organization` } },
      { '@type': 'SoftwareApplication', '@id': `${siteOrigin}/#software`, name: 'MoDeck', url: `${siteOrigin}/`, applicationCategory: 'MultimediaApplication', operatingSystem: 'Windows, macOS', description: page.description, publisher: { '@id': `${siteOrigin}/#organization` } },
    ],
  };
  if (!page.path || page.index === false) return null;
  const graph = [{
    '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'MoDeck', item: `${siteOrigin}/` },
      { '@type': 'ListItem', position: 2, name: page.name, item: siteOrigin + page.path },
    ],
  }];
  if (page.name === 'Review') graph.push({
    '@type': 'Article', headline: page.heading, description: page.description,
    image: siteOrigin + page.image, mainEntityOfPage: siteOrigin + page.path,
    author: { '@type': 'Organization', name: review.author, url: siteOrigin },
    publisher: { '@type': 'Organization', name: 'MoDeck', url: siteOrigin },
    dateModified: review.lastReviewed,
  });
  return { '@context': 'https://schema.org', '@graph': graph };
}
